<awair-device-selection class="__device-selection"
                        [hoveredSnapshot]="hoveredDeviceSnapshot$ | async"
                        [selectedSnapshots]="selectedDeviceSnapshots$ | async"
                        [temperatureUnit]="(selfOrganizationUser$ | async)?.tempUnit">
</awair-device-selection>
<div class="__grid-container">
  <div class="dropdown-container">

    <awair-dropdown2-wrapper [buttonText]="'Filter'"
                             [buttonBadge]="checkedFilterCount$ | async"
                             [isSmall]="true">

      <!--Group Filter-->
      <awair-dropdown2-header [isSmall]="true">
        Group<span class="filter-category-total">{{(groupListWithStatus$ | async).length}}</span>
      </awair-dropdown2-header>
      <awair-dropdown2-menu-checkbox *ngFor="let groupWithStatus of groupListWithStatus$ | async | objArraySort:'name'"
                                     [isSmall]="true"
                                     [hasNoClickState]="true"
                                     [isChecked]="groupWithStatus.isChecked"
                                     (click)="selectGroup(groupWithStatus)">
        {{groupWithStatus.name}}
      </awair-dropdown2-menu-checkbox>

      <!--Floor Filter-->
      <awair-dropdown2-header [isSmall]="true">
        Floor<span class="filter-category-total">{{(floorListWithStatus$ | async).length}}</span>
      </awair-dropdown2-header>
      <awair-dropdown2-menu-checkbox *ngFor="let floorWithStatus of floorListWithStatus$ | async | objArraySort:'name'"
                                     [isSmall]="true"
                                     [hasNoClickState]="true"
                                     [isChecked]="floorWithStatus.isChecked"
                                     (click)="selectFloor(floorWithStatus)">
        {{floorWithStatus.name}}
      </awair-dropdown2-menu-checkbox>

      <!--Condition Filter-->
      <awair-dropdown2-header [isSmall]="true">
        Status<span class="filter-category-total">{{(conditionListWithStatus$ | async).length}}</span>
      </awair-dropdown2-header>
      <awair-dropdown2-menu-checkbox *ngFor="let conditionWithStatus of conditionListWithStatus$ | async | objArraySort:'name'"
                                     [isSmall]="true"
                                     [hasNoClickState]="true"
                                     [isChecked]="conditionWithStatus.isChecked"
                                     (click)="selectCondition(conditionWithStatus)">
        {{conditionWithStatus.condition}}
      </awair-dropdown2-menu-checkbox>
      <!--<awair-dropdown2-menu-checkbox *ngFor="let eachCondition of Condition | enumToArray"-->
                                     <!--[isSmall]="true"-->
                                     <!--(click)="selectCondition(eachCondition)">-->
        <!--{{eachCondition}}-->
      <!--</awair-dropdown2-menu-checkbox>-->
    </awair-dropdown2-wrapper>

    <!-- Export -->
    <div class="aw-dropdown-btn" style="margin-left: auto;" [routerLink]="['/dashboard/export']"
         *ngIf="(selfOrganizationUser$ | async)?.role !== OrganizationUserRole.Member">
      <object type="image/svg+xml" style="width: 13px; height: 13px; margin-right: 8px; padding-bottom: 4px;"
              data="assets/images/header/ic_export.svg">
        Your browser does not support SVGs
      </object>
      <span style="margin-right: 8px;">Export</span>
    </div>
    <!-- /.Export -->
  </div>

  <!-- No Device Message -->
  <div class="grid-list-wrapper" *ngIf="(devices$ | async)?.length === 0">
    <div class="no-device-guide">
      <h1>Welcome to your SGS AirSense Dashboard!</h1>
      <p>Get started by adding devices to your account through the Awair app.</p>
    </div>
  </div>
  <!-- /.No Device Message -->
  <!-- Device Grid List -->
  <ng-container *ngIf="(selectedDeviceUuids$ | async) as selectedDeviceUuids">
    <div class="grid-list-wrapper" *ngIf="(devices$ | async)?.length > 0" awairScrollPrevent>
      <mat-grid-list cols="4" rowHeight="55px">
        <mat-grid-tile *ngFor="let filteredDeviceWithPolledAirDatum of filteredDevicesWithPolledAirData$ | async">
          <!-- Device Nugget -->
          <awair-device-nugget [deviceName]="filteredDeviceWithPolledAirDatum?.device?.deviceName"
                               [deviceType]="filteredDeviceWithPolledAirDatum?.device?.deviceType | deviceTypeName"
                               [email]="filteredDeviceWithPolledAirDatum?.device?.email"
                               [nuggetMode]="isNotiSetting ? NuggetMode.NotificationSetting : NuggetMode.Default"
                               [hasNotification]="triggerEntities != null ? (triggerEntities[filteredDeviceWithPolledAirDatum?.device?.uuid].hashCode != null) : false"
                               [indexDotColor]="filteredDeviceWithPolledAirDatum?.polledAirDatum?.isOnline ? (filteredDeviceWithPolledAirDatum?.polledAirDatum?.score | scoreToColor) : '#CDD3D8'"
                               [ownerFirstName]="filteredDeviceWithPolledAirDatum?.device?.ownerFirstName"
                               [ownerLastName]="filteredDeviceWithPolledAirDatum?.device?.ownerLastName"
                               [isSelected]="selectedDeviceUuids.indexOf(filteredDeviceWithPolledAirDatum.device.uuid) !== -1"
                               (click)="select(filteredDeviceWithPolledAirDatum?.device, selectedDeviceUuids)"
                               (mouseover)="hoverDevice(filteredDeviceWithPolledAirDatum?.device)"
                               (mouseout)="hoverOut()">
          </awair-device-nugget>
          <!-- /.Device Nugget -->
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </ng-container>
  <!-- /.Device Grid List -->
</div>
<!-- Loading -->
<awair-loading *ngIf="!(isGetDevicesLoaded$ | async)"></awair-loading>
<!-- /.Loading -->
